import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiFolderAccount } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

import { RESELLER_CONSOLE } from '../../keys';
import { reseller } from '../../routes';

export interface ResellerSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

const ResellerSideNavigation = ({ isAllowed, ...restOfProps }: ResellerSideNavigationProps) => {
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            label={translateKey(RESELLER_CONSOLE.RESELLER_CONSOLE)}
            icon={mdiFolderAccount}
            route={reseller()}
        />
    );
};

ResellerSideNavigation.displayName = 'ResellerSideNavigation';

export { ResellerSideNavigation };
